import {
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  DialogProps as MuiDialogProps,
} from '@mui/material';
import { ReactNode } from 'react';

export interface DialogProps extends Omit<MuiDialogProps, 'title'> {
  title?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  onOpenChange?: (open: boolean) => void;
}

export const Dialog = ({ title, footer, children, onOpenChange, onClose, ...props }: DialogProps) => {
  const handleClose = (event: React.SyntheticEvent<HTMLElement>, reason?: 'backdropClick' | 'escapeKeyDown') => {
    if (onOpenChange) {
      onOpenChange(false);
    }
    if (onClose) {
      onClose(event, reason);
    }
  };

  return (
    <MuiDialog 
      {...props} 
      onClose={handleClose}
    >
      {title && <MuiDialogTitle>{title}</MuiDialogTitle>}
      <MuiDialogContent>{children}</MuiDialogContent>
      {footer && <MuiDialogActions>{footer}</MuiDialogActions>}
    </MuiDialog>
  );
};

export const DialogTitle = MuiDialogTitle;
export const DialogContent = MuiDialogContent;
export const DialogActions = MuiDialogActions;